import { render, staticRenderFns } from "./PriorKnowledgeResultsUser.vue?vue&type=template&id=8eb03f72&"
import script from "./PriorKnowledgeResultsUser.vue?vue&type=script&lang=js&"
export * from "./PriorKnowledgeResultsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports